"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
const globalErrorCode_1 = require("../global/model/error/globalErrorCode");
const productError_1 = require("./model/error/productError");
class Product {
    constructor(instance) {
        this.instance = instance;
    }
    createProduct(token, productTemplate, name, sku, description, fields, images) {
        return new Promise((resolve, reject) => {
            const URL = '/products';
            if (!token) {
                reject(new productError_1.ProductError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const data = new FormData();
            if (name)
                data.set('name', name);
            if (sku)
                data.set('sku', sku);
            data.set('productTemplate', productTemplate);
            if (fields)
                data.set('fields', fields);
            if (description)
                data.set('description', description);
            if (images)
                data.set('image_url', images);
            const authStr = 'Bearer '.concat(token);
            const config = {
                headers: {
                    Authorization: authStr,
                }
            };
            this.instance.post(URL, data, config)
                .then((res) => {
                const product = res.data;
                resolve(product);
            })
                .catch((err) => {
                reject(this.handleErrorOfProduct_(err));
            });
        });
    }
    getAllProducts(token) {
        return new Promise((resolve, reject) => {
            const URL = '/products';
            if (!token) {
                reject(new productError_1.ProductError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.get(URL, config)
                .then((res) => {
                const product = res.data;
                resolve(product);
            })
                .catch((err) => {
                reject(this.handleErrorOfProduct_(err));
            });
        });
    }
    getProductByID(token, id) {
        return new Promise((resolve, reject) => {
            const URL = `/products/${id}`;
            if (!token) {
                reject(new productError_1.ProductError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.get(URL, config)
                .then((res) => {
                const product = res.data;
                resolve(product);
            })
                .catch((err) => {
                reject(this.handleErrorOfProduct_(err));
            });
        });
    }
    getProductByTemplateName(token, templateName) {
        return new Promise((resolve, reject) => {
            const URL = `/products/?productTemplate=${templateName}`;
            if (!token) {
                reject(new productError_1.ProductError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.get(URL, config)
                .then((res) => {
                const products = res.data;
                if (products.length > 0) {
                    resolve(products[0]);
                }
                else {
                    resolve(undefined);
                }
            })
                .catch((err) => {
                reject(this.handleErrorOfProduct_(err));
            });
        });
    }
    deleteProductByID(token, id) {
        return new Promise((resolve, reject) => {
            const URL = `/products/${id}`;
            if (!token) {
                reject(new productError_1.ProductError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.delete(URL, config)
                .then((res) => {
                resolve(res.data.message === 'Successfully deleted');
            })
                .catch((err) => {
                reject(this.handleErrorOfProduct_(err));
            });
        });
    }
    updateProductByID(token, productInfo) {
        const theProductInfo = productInfo;
        return new Promise((resolve, reject) => {
            const URL = `/products/${productInfo.id}`;
            delete theProductInfo.id;
            if (!token) {
                reject(new productError_1.ProductError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const data = new FormData();
            if (productInfo.name)
                data.set('name', productInfo.name);
            if (productInfo.sku)
                data.set('sku', productInfo.sku);
            data.set('productTemplate', productInfo.productTemplate);
            if (productInfo.fields)
                data.set('fields', productInfo.fields);
            if (productInfo.description) {
                data.set('description', productInfo.description);
            }
            if (productInfo.image_url) {
                data.set('image_url', productInfo.image_url);
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.put(URL, data, config)
                .then((res) => {
                const product = res.data;
                resolve(product);
            })
                .catch((err) => {
                reject(this.handleErrorOfProduct_(err));
            });
        });
    }
    handleErrorOfProduct_(error) {
        if (error.response.data.error !== 'Bad Request') {
            return new productError_1.ProductError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, error.response.data.error);
        }
        else {
            return new productError_1.ProductError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, error.response.data.message);
        }
    }
}
exports.Product = Product;
//# sourceMappingURL=product.js.map